import withSignalEventsTracking from "app/pages/sales-intelligence/pages/company-analysis/containers/signals/SignalEventList/withSignalEventsTracking";

import SignalsCard from "./SignalsCard";

const SignalsCardTracked = withSignalEventsTracking(SignalsCard);

export default SignalsCardTracked;
